module.exports = __webpack_public_path__ + "static/openapp-a49af38eb84ec7687332d136b5af0bcf.png";